import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export const constantRoutes = [
    {
        path: '/',
        // name: 'layout',
        redirect: '/home',
        hidden: true,
        component: () => import('@/layout'),
        children: []
    }
]

const router = new VueRouter({
    scrollBehavior: () => ({y: 0}),
    // routes: constantRoutes,
    mode: 'history'
})


router.beforeEach(async (to, from, next) => {

    //TODO 跳转路由取消所有页面请求
    //跳转之前先取消loading
    store.commit('clearLoading');

    if (store.state.routerList.length === 0) {

        await store.dispatch('getRouteList')

        let list = [
            ...constantRoutes,
            ...store.state.routerList
        ]

        list.forEach(res=>{
            router.addRoute(res);
        })

        next({...to, replace: true})
    } else {
        next()
    }
})


export default router


